export default "__VITE_ASSET__Bu$Igw_7AVO2cewv3Xfqbg__";